import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Award, TrendingUp, Heart, Users, BookOpen } from 'lucide-react';
const benefits = [{
  icon: BookOpen,
  title: 'Metodología Probada',
  desc: 'Sistema paso a paso para que domines la técnica desde el primer día.'
}, {
  icon: TrendingUp,
  title: 'Negocio Rentable',
  desc: 'Atrae clientas, fija precios y escala tus ingresos rápidamente.'
}, {
  icon: Heart,
  title: 'Cuidado Integral',
  desc: 'Domina la anatomía facial para resultados seguros y espectaculares.'
}, {
  icon: Users,
  title: 'Comunidad Exclusiva',
  desc: 'Únete a cientos de mujeres que comparten tus mismas metas.'
}, {
  icon: Sparkles,
  title: 'Actualizaciones',
  desc: 'Acceso de por vida al material y nuevas técnicas del mercado.'
}];
export const Benefits = () => {
  return <section className="py-16 bg-base relative" data-id="element-16">
      <div className="container mx-auto px-6 max-w-6xl" data-id="element-17">
        <div className="text-center mb-12" data-id="element-18">
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-text-main mb-3" data-id="element-19">
            Todo lo que necesitas para{' '}
            <span className="text-fuchsia italic" data-id="element-20">convertirte en experta</span>
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-21">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="bg-white p-5 rounded-2xl shadow-sm border border-pink-light hover:shadow-soft transition-shadow duration-300 flex items-start gap-4" data-id="element-22">
              <div className="w-10 h-10 rounded-full bg-pink-light flex items-center justify-center shrink-0" data-id="element-23">
                <benefit.icon className="w-5 h-5 text-gold-dark" data-id="element-24" />
              </div>
              <div data-id="element-25">
                <h3 className="text-base font-serif font-bold text-text-main mb-1" data-id="element-26">
                  {benefit.title}
                </h3>
                <p className="text-text-muted text-sm leading-snug" data-id="element-27">
                  {benefit.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};